// eslint-disable-next-line require-jsdoc
// eslint-disable-next-line require-jsdoc
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
// import IndeterminateShort from '@ids/indeterminate-short';
import styled from 'styled-components';
// import fetch from "node-fetch";
import Button from '@ids/button';
import Dropdown, { MenuItem } from '@ids-ts/dropdown';
import { Modal, ModalContent } from '@ids/modal-dialog';
import { Link } from 'react-router-dom';
import { productListFetch, addToCart } from '../../services/productDataService';
import { taxFormUnavailableMessage } from '../../../assets/pagedata/constant';
import { PerfAddToCartPricingSection } from '../Product/PricingSections/index';
import { TaxAddToCartPricing } from '../Product/PricingSections/TaxAddToCartPricing';
/*
 * Responsive grid supports mobile or xs mode at 480px.
 * But according to specs it needs to be 375px.
 *Include the custom built css for mobile everytime the responsivegrid is included.
 */
import '@ids-alpha/responsive-grid';
import '../../../stylesheets/responsiveGridStyles.scss';
import '../../../stylesheets/productlist.scss';
import { Recommended } from './Recommended';
import { ReduxEvent } from '../../../assets/pagedata/constant';
import SimpleStartingAtPriceBlock from '../Common/SimpleStartingAtPriceBlock';
import {
  sortByQuantityAsc,
  sortByPriceAsc,
  isTaxFormUnavailable,
  getCurrentFisicalYear,
  taxFormsNextAvlDate,
  createOutOfStockList,
  isProductOutOfStock,
  currencyFormatter,
  convertToSnakeCase,
  getImageSrc
} from '../Util/CommonUtils';
import LearnMoreLink from '../Common/LearnMoreLink';
// import mostPopular from '../../../assets/images/IM/Checks/ic-badge-most-popular-magenta-1x.png';
import { MostPopularBadge } from '../Common/MostPopularBadge';
import TaxFormPartsChart from '../../../assets/images/IM/Product Category/Tax_Forms_parts_chart_2022.jpg';
import Loader from '../Common/Loader';
import { ProductFaq } from '../Product/ProductFaq';

export const SpinnerWrapper = styled.div`
    left: 50%;
    top: 20%;
    transform: translate(-50%, -50%);
    position: absolute;
}`;

// eslint-disable-next-line require-jsdoc
const ProductListPage = (props) => {
  const { pageData } = props;
  const productListReducer = useSelector((state) => state.productListReducer);
  const dispatch = useDispatch();
  const [pricing, setPricing] = useState([]);
  const [fetchError, setFetchError] = useState(false);
  const [openModal, setOpenModel] = useState(false);
  const [selectedLgImg, setSelectedLgImg] = useState(null);
  const [LrgHeight, setLrgHeight] = useState(null);
  const [LrgWidth, setLrgWidth] = useState(null);
  const [selectedSkus, setSelectedSkus] = useState([]);
  const [submittedPFIDs, setSubmittedPFIDs] = useState([]);
  const [openTaxModal, setOpenTaxModel] = useState(false);
  const [image, setImage] = useState(null);
  const [imageLg, setImageLg] = useState(null);
  const [outOfStockList, setOutOfStockList] = useState(null);
  const [prodAvailable, setProdAvailable] = useState({});
  const [showLoader, setLoading] = useState(false);
  let isOutOfStock;
  // eslint-disable-next-line require-jsdoc
  const loadData = (pricingData) => {
    setPricing(pricingData);
    dispatch({ type: ReduxEvent.GET_PRODUCT_DATA_SUCESS, data: { loading: false } });
    props.logToIMWebLogger(
      'info',
      `PrductListPage: dispatch pricing data successful, for ${pageData.Department.DeptName} page.`,
    );
    if (typeof props.loadDataToParent === 'function') {
      props.loadDataToParent(pricingData);
    }
  };
  const selectDefaultSkus = (data) => {
    const skus = [];
    for (let i = 0; i < pageData.ProductSections.length; i++) {
      const prodSec = pageData.ProductSections[i];
      for (let j = 0; j < prodSec.Products.length; j++) {
        const prod = prodSec.Products[j];

        if (prod.HasPricing) {
          let p = data.find((x) => x.find((y) => y.PfID === prod.PFID))
            ? data.find((x) => x.find((y) => y.PfID === prod.PFID)).sort(sortByQuantityAsc)
            : [];

          if (prod.Sku) {
            p = p.filter((z) => z.Sku.toLowerCase().indexOf(prod.Sku) > -1);
          }
          if (p.length > 0) skus.push(`${p[0].PfID}_${p[0].Sku}`);
        }
        // Set the sku for products which have only one sku by default
        else if (prod.DefaultSku) {
          let p = data.find((x) => x.find((y) => y.PfID === prod.PFID));
          p = p.filter((z) => z.Sku.toLowerCase().indexOf(prod.DefaultSku) > -1);
          if (p.length > 0) skus.push(`${p[0].PfID}_${p[0].Sku}`);
        }
      }
    }
    setSelectedSkus(skus);
    return skus;
  };

  const checkForProductAvailabilty = (ofsLst, defSkuList) => {
    const prodAvailablility = {};
    defSkuList.forEach((e) => {
      const pfid = e.split('_')[0];
      const sku = e.split('_')[1];
      const isSkuOutOfStock = isProductOutOfStock(
        {
          pfid: null,
          sku,
        },
        ofsLst,
      );

      if (isSkuOutOfStock?.displayOutOfStock) {
        prodAvailablility[pfid] = isSkuOutOfStock.outOfStockMessage;
      } else {
        delete prodAvailablility[pfid];
      }
    });
    setProdAvailable(prodAvailablility);
  };

  const { loading } = productListReducer;

  const getDistinctItemNumbers = (pfid) => {
    const productList = pricing.find((x) => x.find((y) => y.PfID === pfid))
      ? pricing.find((x) => x.find((y) => y.PfID === pfid))
      : [];
    let distinctList = [];
    if (productList && productList.length > 0) {
      distinctList = [...new Set(productList.map((prdct) => prdct.Sku.split('-')[0]))];
    }
    return distinctList.join(', ');
  };

  useEffect(() => {
    props.logToIMWebLogger(
      'info',
      `PrductListPage: ${pageData.Department.DeptName} page load completed`,
    );
    // eslint-disable-next-line require-jsdoc
    const getProductInfo = async (payload) => {
      productListFetch(payload)
        .then((json) => {
          if (props.handleStockData) {
            props.handleStockData(json);
          }
          loadData(json);
          props.logToIMWebLogger(
            'info',
            `PrductListPage: productListFetch completed successfully for ${pageData.Department.DeptName} page`,
          );
          const defaultskuList = selectDefaultSkus(json);
            const ofsList = createOutOfStockList(json);
            setOutOfStockList(ofsList);
            checkForProductAvailabilty(ofsList, defaultskuList);
          setLoading(false);
        })
        .catch((err) => {
          setFetchError(true);
          props.logToIMWebLogger(
            'error',
            `PrductListPage: productListFetch failed for ${pageData.Department.DeptName} page. Error: ${err}`,
          );

          // Send it to analytics
          props.logToAnalytics({
            eventList: 'error',
            error: `PrductListPage: productListFetch failed for ${pageData.Department.DeptName} page. Error: ${err}`,
          });
          setLoading(false);
        });
    };

    if (pageData.Department.FetchPricing) {
      setLoading(true);
      getProductInfo(pageData.Department.RequestBody);
    }

    // Send it to analytics
    const p = [];
    if (pageData.Department.RequestBody) {
      pageData.Department.RequestBody.forEach((e) => {
        p.push([e]);
      });
    }

    props.logToAnalytics({
      aryProducts: p,
      eventList: 'prodview',
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPrices = (pfid, sku = null) => {
    let prices = pricing.find((x) => x.find((y) => y.PfID === pfid))
      ? pricing.find((x) => x.find((y) => y.PfID === pfid)).sort(sortByQuantityAsc)
      : [];

    if (sku) {
      prices = prices.filter((z) => z.Sku.toLowerCase().indexOf(sku) > -1);
    }

    return prices;
  };

  const handleModalOpen = (imgPath, imgLrgHeight, imgLrgWidth) => {
    // Example usage of IM Logger
    props.logToIMWebLogger('info', 'Opened Modal');

    setOpenModel(true);
    setSelectedLgImg(imgPath);
    setLrgHeight(imgLrgHeight);
    setLrgWidth(imgLrgWidth);
  };

  const handleModalClose = () => {
    setOpenModel(false);
    setSelectedLgImg(null);
  };

  const navigateSuccess = (pageInfo) => {
    dispatch({
      type: ReduxEvent.PAGE_DATA,
      data: {
        pageData: {
          cartCount: pageInfo.CartCount,
          login: pageInfo.login,
          promotionMessage: pageInfo.PromotionMessage,
        },
      },
    });
    props.history.push('/cart');
  };

  const handleButtonClick = (pfID) => {
    setSubmittedPFIDs([...submittedPFIDs.filter((x) => x !== pfID), pfID]);
    const skuForPfID = selectedSkus.find((x) => x.indexOf(pfID) > -1);
    if (!skuForPfID) {
      return;
    }

    const params = {
      PfId: pfID,
      SKU: skuForPfID.split('_')[1],
      IsCustomizable: '0',
    };
    addToCart(params, navigateSuccess);
  };
  const handleChange = (e) => {
    const pfID = e.target.value.split('_')[0];
    const sku = e.target.value.split('_')[1];
      const isSkuOutOfStock = isProductOutOfStock(
        {
          pfid: null,
          sku,
        },
        outOfStockList,
      );
      const prodAvailablility = JSON.parse(JSON.stringify(prodAvailable));
      if (isSkuOutOfStock?.displayOutOfStock) {
        prodAvailablility[pfID] = isSkuOutOfStock.outOfStockMessage;
      } else {
        delete prodAvailablility[pfID];
      }

      setProdAvailable(prodAvailablility);
    setSelectedSkus([...selectedSkus.filter((x) => x.indexOf(pfID) === -1), e.target.value]);
  };

  const getStartingAtPricingForPfID = (pfID, sku) => {
    let ele = pricing.find((x) => x.find((y) => y.PfID === pfID));

    if (ele) {
      if (sku) {
        ele = ele.filter((x) => x.Sku.indexOf(sku) === 0);
      }

      if (ele.length > 0) {
        /* const ele1 = ele.filter((item) => {
          return item.Quantity !== null;
        }); */
        return ele.sort(sortByPriceAsc)[0];
      }
    }

    return null;
  };

  const getWarningText = (pfId) => {
    if (submittedPFIDs.find((x) => x === pfId) && !selectedSkus.find((x) => x.indexOf(pfId) > -1)) {
      return 'Please select a value.';
    }
    return '';
  };

  const getSelectedvalue = (pfID) => {
    const sku = selectedSkus.find((x) => x.indexOf(pfID) > -1);
    return sku || null;
  };

  const handleTaxModalClose = () => {
    setOpenTaxModel(false);
  };

  const prodPriceInfoCallBack = (response) => {
    if (response) {
      setImage(response.SmallImageUrl);
      setImageLg(response.LargeImageUrl);
    } else {
      setImage(pageData.Department.Image);
      setImageLg(pageData.Department.ImageLg);
    }
  };

  const handleOutOfStockProductList = (pfid, sku) => {
    isOutOfStock = {
      displayOutOfStock: false,
    };


    if ( outOfStockList && outOfStockList.length >= 1) {
      const ofsPfid = isProductOutOfStock(
        {
          pfid,
          sku,
        },
        outOfStockList,
      );
      isOutOfStock = ofsPfid;
      return isOutOfStock;
    }
    return isOutOfStock;
  };

  return (
    <div>
      <Loader show={showLoader} size={80} loadingText="Loading.." />
      <div className="container-center-lg">
        <div className="margin-main-section">
          <div className="row department-section">
            <div className="col-lg-12 col-sm-12 col-xs-12">
              <h1 className="product_list_header">{pageData.Department.DeptName}</h1>
            </div>
          </div>
          {pageData.Department.DepSubHeader && (
            <div className="row">
              <div className="col-lg-12 col-sm-12 col-xs-12">
                <div className="product_list_sub_header font-wgt-600">
                  {pageData.Department.DepSubHeader}
                </div>
              </div>
            </div>
          )}
          {pageData.Department.DeptDesc && (
            <div className="row all-tax-form-desc-align">
              <div className="col-lg-12 col-sm-12 col-xs-12">
                <div className="department-desc product_list_desc product-list-dept-dec">
                  {pageData.Department.DeptDesc}
                </div>
              </div>
            </div>
          )}
          <div className="header-prod-space" />
          {pageData.ProductSections.map((section, key) => {
            return (
              <div key={key}>
                {section.SectionHeader && (
                  <div className="row">
                    <div className="col-lg-12 col-sm-12 col-xs-12">
                      <h2 className="margin-bottom-20">{section.SectionHeader}</h2>
                    </div>
                  </div>
                )}

                {section.Products.map((product, indexKey) => {
                  return (
                    <div key={indexKey} className="row margin-bottom-60 product_in_list">
                      <div className="col-sm-6 col-md-4 col-lg-4 col-xs-12 image-col">
                        {!!product.PricingInformation &&
                        product.PricingInformation.Type === 'PERF01' &&
                        product.IsMultiProductW2Blank &&
                        image ? (
                          <div
                            role="button"
                            tabIndex={0}
                            className="align-items-center"
                            data-wa-link="View Large Image"
                            onClick={() => {
                              if (imageLg) handleModalOpen(getImageSrc(imageLg));
                            }}
                            onKeyUp={(e) => {
                              imageLg && e.key === 'Enter'
                                ? handleModalOpen(getImageSrc(imageLg))
                                : e.preventDefault();
                            }}
                            style={{
                              cursor: (imageLg && 'pointer') || 'default',
                            }}
                          >
                            {/* {product.MostPopular && (
                              <img alt="..." className="most-popular" src={mostPopular} />
                            )} */}
                            <img
                              className={
                                product.ImageFull
                                  ? 'center-image margin-bottom-20 img-full-height'
                                  : 'center-image margin-bottom-20'
                              }
                              style={product.ImageFitContent ? { maxHeight: 'fit-content' } : {}}
                              height={product.ImageHeight ? product.ImageHeight : 'auto'}
                              width={product.ImageWidth ? product.ImageWidth : 'auto'}
                              alt="..."
                              loading={indexKey > 2 ? 'lazy' : 'eager'}
                              src={getImageSrc(image)}
                              onLoad={() => {
                                props.markUserTime(product.ProductName);
                              }}
                            />
                            {imageLg && (
                              <div>
                                <p
                                  className="lnk-view-lg-img universal-link"
                                  data-ui-object="link"
                                  data-refer-ui-access-point={`view_large_image_${product.ProductName}`}
                                >
                                  View larger image
                                </p>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div
                            role="button"
                            tabIndex={0}
                            className="align-items-center"
                            data-wa-link="View Large Image"
                            onClick={(e) => {
                              product.ImageSrcOptimizedLrg || product.ImageLrg
                                ? handleModalOpen(
                                    getImageSrc(product.ImageSrcOptimizedLrg || product.ImageLrg),
                                    product.ImageHeightLrg,
                                    product.ImageWidthLrg,
                                  )
                                : e.preventDefault();
                            }}
                            loading={indexKey > 2 ? 'lazy' : 'eager'}
                            onKeyUp={(e) => {
                              (product.ImageSrcOptimizedLrg || product.ImageLrg) &&
                              e.key === 'Enter'
                                ? handleModalOpen(
                                    getImageSrc(product.ImageSrcOptimizedLrg || product.ImageLrg),
                                    product.ImageHeightLrg,
                                    product.ImageWidthLrg,
                                  )
                                : e.preventDefault();
                            }}
                            style={{
                              cursor: (imageLg && 'pointer') || 'default',
                            }}
                          >
                            {product.ImageSrcOptimized ? (
                              <picture>
                                <source
                                  className={
                                    product.ImageFull
                                      ? 'center-image margin-bottom-20 img-full-height margin-top--36px'
                                      : 'center-image margin-bottom-20 margin-top--36px'
                                  }
                                  style={
                                    product.ImageFitContent ? { maxHeight: 'fit-content' } : {}
                                  }
                                  height={product.ImageHeight ? product.ImageHeight : 'auto'}
                                  width={product.ImageWidth ? product.ImageWidth : 'auto'}
                                  alt="..."
                                  loading={indexKey > 2 ? 'lazy' : 'eager'}
                                  srcset={getImageSrc(product.ImageSrcOptimized)}
                                  type="image/webp"
                                  onLoad={() => {
                                    props.markUserTime(product.ProductName);
                                  }}
                                />
                                <img
                                  className={
                                    product.ImageFull
                                      ? 'center-image margin-bottom-20 img-full-height'
                                      : 'center-image margin-bottom-20'
                                  }
                                  style={
                                    product.ImageFitContent ? { maxHeight: 'fit-content' } : {}
                                  }
                                  height={product.ImageHeight ? product.ImageHeight : 'auto'}
                                  width={product.ImageWidth ? product.ImageWidth : 'auto'}
                                  alt="..."
                                  loading={indexKey > 2 ? 'lazy' : 'eager'}
                                  src={getImageSrc(product.ImageSrc)}
                                  onLoad={() => {
                                    props.markUserTime(product.ProductName);
                                  }}
                                />
                              </picture>
                            ) : (
                              <img
                                className={
                                  product.ImageFull
                                    ? 'center-image margin-bottom-20 img-full-height'
                                    : 'center-image margin-bottom-20'
                                }
                                style={product.ImageFitContent ? { maxHeight: 'fit-content' } : {}}
                                height={product.ImageHeight ? product.ImageHeight : 'auto'}
                                width={product.ImageWidth ? product.ImageWidth : 'auto'}
                                alt="..."
                                loading={indexKey > 2 ? 'lazy' : 'eager'}
                                src={getImageSrc(product.ImageSrc)}
                                onLoad={() => {
                                  props.markUserTime(product.ProductName);
                                }}
                              />
                            )}
                            {(product.ImageSrcOptimizedLrg || product.ImageLrg) && (
                              <div>
                                <p
                                  className="lnk-view-lg-img universal-link"
                                  data-ui-object="link"
                                  data-refer-ui-access-point={`view_large_image_${product.ProductName}`}
                                >
                                  {product.ImageSrcOptimizedLrg
                                    ? 'View larger image'
                                    : 'View larger image'}
                                </p>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12 desc-col">
                        <div className="content-padding">
                          {product.MostPopular && <MostPopularBadge />}
                          <h2 className="margin-bottom-20">{product.ProductName}</h2>
                          {product.ActualPrice !== 0.0 && (
                            <SimpleStartingAtPriceBlock
                              pricing={getStartingAtPricingForPfID(product.PFID, product.Sku)}
                              showQuantity={product.Quantity}
                              error={fetchError}
                              location={props.location}
                            />
                          )}
                          <p className="margin-bottom-20">
                            {product.ProductDesc}
                            {product.LearnMore && (
                              <span
                                onClick={props.openModal}
                                className="irs-learn-more"
                                style={{ cursor: 'pointer' }}
                              >
                                {product.LearnMore}
                              </span>
                            )}
                          </p>
                          <p className="margin-bottom-20">{product.ProductSubDesc}</p>

                          {product.ProductDescExtra && (
                            <p className="margin-bottom-20">
                              Item numbers: {getDistinctItemNumbers(product.PFID)}
                            </p>
                          )}

                          {!!product.EachKitContains &&
                            product.EachKitContains.length &&
                            product.EachKitContains.length > 1 && (
                              <p className="margin-bottom-20">
                                Each kit contains:
                                <ul className="kits-list">
                                  {product.EachKitContains.map((inKit, index) => {
                                    return <li key={index}>{inKit}</li>;
                                  })}
                                </ul>
                              </p>
                            )}

                          {!!product.inListDesc &&
                            product.inListDesc.length &&
                            product.inListDesc.length > 1 && (
                              <p className="margin-bottom-20">
                                <ul>
                                  {product.inListDesc.map((listDesc, listDescIndex) => {
                                    return <li key={listDescIndex}>{listDesc}</li>;
                                  })}
                                </ul>
                              </p>
                            )}

                          {!!product.Specifications &&
                            product.Specifications.length &&
                            product.Specifications.length > 0 && (
                              <div className="product-specification-container margin-bottom-20">
                                <p className="margin-bottom-10 font-wgt-600">Specifications</p>
                                <ul>
                                  {product.Specifications.map((c, index) => {
                                    return (
                                      // eslint-disable-next-line react/no-array-index-key
                                      <li key={`Specs-${index}`}>{c}</li>
                                    );
                                  })}
                                  {product.ProductTaxDescExtra && (
                                    <li className="margin-bottom-10">
                                      <p className="p2-regular margin-bottom-10">
                                        Item numbers: {getDistinctItemNumbers(product.PFID)}
                                      </p>
                                    </li>
                                  )}
                                </ul>
                              </div>
                            )}
                          {!!product.Compatibility &&
                            product.Compatibility.length &&
                            product.Compatibility.length > 0 && (
                              <div className="margin-bottom-20 product-compatability-container">
                                <p className="margin-bottom-10 font-wgt-600">Compatibility</p>
                                {product.Compatibility.map((c, keyIndex, arr) => {
                                  return (
                                    <p
                                      key={`Compatibility-${keyIndex}`}
                                      className={`${
                                        key === arr.length - 1
                                          ? 'p2-regular'
                                          : 'margin-bottom-20 p2-regular'
                                      }`}
                                    >
                                      {c}
                                    </p>
                                  );
                                })}
                              </div>
                            )}

                          {!!product.SpecialNote &&
                            product.SpecialNote.length &&
                            product.SpecialNote.length > 0 && (
                              <div className="special-note-container">
                                <p className="margin-bottom-10 font-wgt-600 p2-regular margin-top-20">
                                  Special Note
                                </p>
                                {product.SpecialNote.map((c, keyVal, arr) => {
                                  return (
                                    <p
                                      key={`SpecialNote-${keyVal}`}
                                      className={`${
                                        key === arr.length - 1
                                          ? 'p2-regular'
                                          : 'margin-bottom-20 p2-regular'
                                      }`}
                                    >
                                      {c}
                                    </p>
                                  );
                                })}
                              </div>
                            )}

                          {!!product.additionalDesc &&
                            product.additionalDesc.length &&
                            product.additionalDesc.length > 1 &&
                            product.additionalDesc.map((desc) => {
                              return <p className="margin-bottom-20">{desc}</p>;
                            })}

                          {((product.LearnMoreLink && !pageData.Department.FetchPricing) ||
                            (product.LearnMoreLink &&
                              handleOutOfStockProductList(product.PFID, null) &&
                              isOutOfStock &&
                              !isOutOfStock.displayOutOfStock)) && (
                            <LearnMoreLink product={product} />
                          )}

                          {pageData.Department.FetchPricing &&
                            product.HasSkuSelection &&
                            handleOutOfStockProductList(product.PFID, null) &&
                            isOutOfStock &&
                            !isOutOfStock.displayOutOfStock && (
                              <div>
                                <TaxAddToCartPricing
                                  {...props}
                                  pfId={product.PFID}
                                  pricing={getPrices(product.PFID, product.Sku)}
                                  displayStateHelperText={product.DisplayStateHelperText}
                                  indexKey={indexKey}
                                  StateLabelText={product.StateLabelText}
                                  outOfStockItems={outOfStockList}
                                />
                              </div>
                            )}
                          {pageData.Department.FetchPricing &&
                            product.HasPricing &&
                            handleOutOfStockProductList(product.PFID, null) &&
                            isOutOfStock &&
                            !isOutOfStock.displayOutOfStock && (
                              <div className="margin-bottom-20">
                                <Dropdown
                                  data-wa-link="price"
                                  data-ui-object="dropdown"
                                  data-refer-ui-access-point={`price_dropdown_${product.ProductName}`}
                                  data-ui-object-details="Dropdown"
                                  theme="quickbooks"
                                  buttonType="secondaryGhost"
                                  aria-label="Dropdown"
                                  className="dropdown-ie product_list_dropdown dropdown-background-color-white"
                                  placeholder={loading ? 'Loading....' : 'Select Value'}
                                  onChange={(e) => handleChange(e)}
                                  errorText={fetchError ? 'Unable to fetch the value.' : null}
                                  warningText={getWarningText(product.PFID)}
                                  value={getSelectedvalue(product.PFID)}
                                >
                                  {getPrices(product.PFID, product.Sku).map((p) => {
                                    return (
                                      <MenuItem
                                        key={`${p.PfID}_${p.Quantity}`}
                                        value={`${p.PfID}_${p.Sku}`}
                                      >{`${p.Quantity} for ${
                                        p.DiscPrice
                                          ? currencyFormatter(p.DiscPrice)
                                          : currencyFormatter(p.ListPrice)
                                      }`}</MenuItem>
                                    );
                                  })}
                                </Dropdown>
                              </div>
                            )}
                          {pageData.Department.FetchPricing &&
                            product.HasPricingInformation &&
                            product.IsMultiProductW2Blank &&
                            product.PricingInformation.Type === 'PERF01' &&
                            handleOutOfStockProductList(product.PFID, null) &&
                            isOutOfStock &&
                            !isOutOfStock.displayOutOfStock && (
                              <div className="margin-bottom-20">
                                <PerfAddToCartPricingSection
                                  {...props}
                                  pricing={getPrices(product.PFID, product.Sku)}
                                  pricingInformation={product.PricingInformation}
                                  loading={loading}
                                  error={fetchError}
                                  product={product}
                                  callback={prodPriceInfoCallBack}
                                  outOfStockItems={outOfStockList}
                                />
                              </div>
                            )}
                          {/TAX-03|TAX-04|PERF-01/i.test(product.PFID) &&
                          !product.IsMultiProductW2Blank &&
                          isTaxFormUnavailable() ? (
                            <div className="tax-form-unavailable-msg">{`${getCurrentFisicalYear()} ${taxFormUnavailableMessage} ${taxFormsNextAvlDate()}`}</div>
                          ) : product.ButtonLink &&
                            handleOutOfStockProductList(product.PFID, null) &&
                            isOutOfStock &&
                            !isOutOfStock.displayOutOfStock ? (
                            <Link
                              to={product.ButtonLink}
                              data-wa-link={
                                product.ButtonText === 'Order now'
                                  ? `${product.ButtonText}`
                                  : `${product.ButtonText}_${product.ButtonLink}`
                              }
                            >
                              <Button
                                theme="intuit"
                                className="action-button"
                                styleOverrideReason="none"
                                data-ui-object="button"
                                data-refer-ui-access-point={`${convertToSnakeCase(
                                  product.ButtonText,
                                )} | ${convertToSnakeCase(product.ProductName)}`}
                                onClick={() =>
                                  props.markUserTime(`link_${product.ButtonLink.substring(1)}`)
                                }
                              >
                                {product.ButtonText}
                              </Button>
                            </Link>
                          ) : handleOutOfStockProductList(product.PFID, null) &&
                            isOutOfStock &&
                            isOutOfStock.displayOutOfStock ? (
                            <div className="product-unavailable-msg">
                              {isOutOfStock.outOfStockMessage}
                            </div>
                          ) : (
                            product.ButtonText &&
                            !prodAvailable[product.PFID] && (
                              <Button
                                data-wa-link={product.ButtonText}
                                data-ui-object="button"
                                data-refer-ui-access-point={`  ${convertToSnakeCase(
                                  product.ButtonText,
                                )} | ${convertToSnakeCase(product.ProductName)}`}
                                className="action-button"
                                styleOverrideReason="none"
                                onClick={() => handleButtonClick(product.PFID)}
                                theme="intuit"
                              >
                                {product.ButtonText}
                              </Button>
                            )
                          )}
                          {prodAvailable[product.PFID] && (
                            <div className="product-unavailable-msg">
                              {prodAvailable[product.PFID]}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}

          {pageData?.ProdFooterDesc ? (
            <div className="prod_footer_desc prod-footer-desc-margin">
              {pageData.ProdFooterDesc}
            </div>
          ) : (
            <> </>
          )}
        </div>
      </div>

      {pageData.FooterSection && (
        <div className="footer-main-section">
          <div className="container-center-lg">
            <div className="footer-section">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                  <img
                    src={pageData.FooterSection.Image}
                    className="center-image"
                    alt="img"
                    loading="lazy"
                    height="auto"
                    width="auto"
                  />
                </div>
                <div className="col-lg-8 col-md-8 col-sm-6 col-xs-12 col-footer-desc">
                  <h2 className="margin-bottom-20">
                    {pageData.FooterSection.Header.map((h, key) => {
                      return (
                        // eslint-disable-next-line react/no-array-index-key
                        <span key={`header-${key}`}>
                          {h}
                          <br />
                        </span>
                      );
                    })}
                  </h2>
                  <br />
                  {pageData.FooterSection.Paragraphs.map((p, key) => {
                    return (
                      // eslint-disable-next-line react/no-array-index-key
                      <p key={`section-${key}`} className="margin-bottom-20">
                        {p}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* {pageData.Department.Faqs && <Faqs />} */}
      {pageData.Department.HasFaq && (
        <ProductFaq
          FaqDescription={pageData.Department.FaqDescription}
          HasEfileModal={pageData.Department.HasEfileModal}
        />
      )}

      {pageData.Department.Remarks && pageData.Department.Remarks.length > 0 && (
        <div className="container-center-lg">
          <div className="margin-main-section margin-top-20">
            {pageData.Department.Remarks.map((c, key) => {
              return (
                <p
                  key={`Remarks-${key}`}
                  className="margin-bottom-20 p2-small"
                  style={{ fontSize: '13px' }}
                >
                  {c}
                </p>
              );
            })}
          </div>
        </div>
      )}

      {pageData.AlsoRecommended && <Recommended {...props} outOfStockList={outOfStockList} />}
      <Modal
        dismissible
        onClose={() => {
          handleModalClose();
        }}
        open={openModal}
        className="large-image-modal"
        styleOverrideReason="none"
      >
        <ModalContent alignment="center">
          <div style={{ margin: '3rem' }}>
            <picture>
              <source
                alt="..."
                srcSet={`${selectedLgImg}`}
                type="image/webp"
                height={`${LrgHeight}` ? `${LrgHeight}` : 'auto'}
                width={`${LrgWidth}` ? `${LrgWidth}` : 'auto'}
              />
              <img
                alt="..."
                src={`${selectedLgImg}`}
                loading="lazy"
                height={`${LrgHeight}` ? `${LrgHeight}` : 'auto'}
                width={`${LrgWidth}` ? `${LrgWidth}` : 'auto'}
              />
            </picture>
          </div>
        </ModalContent>
      </Modal>

      <Modal
        dismissible
        onClose={() => {
          handleTaxModalClose();
        }}
        className="image-modal"
        open={openTaxModal}
      >
        <ModalContent alignment="center">
          <div>
            <img alt="..." src={TaxFormPartsChart} loading="lazy" />
          </div>
        </ModalContent>
      </Modal>
    </div>
  );
};

ProductListPage.propTypes = {
  pageData: PropTypes.object.isRequired,
  logToIMWebLogger: PropTypes.func.isRequired,
  logToAnalytics: PropTypes.func.isRequired,
  markUserTime: PropTypes.func.isRequired,
};

export default ProductListPage;
